(ns io.daskul.api-contract.active-context
  "Wire contract for the active-context request headers (F-041).

   Active context is a UI preference — which school / branch the user is
   currently looking at — carried per request, separate from the JWT security
   boundary of what they CAN access.

   This namespace is the single source of truth for those header names, and is
   .cljc because both sides of the wire consume it: the webapp clients build
   the headers from `header`, the API middlewares read them via `request-key`,
   and the framework's CORS allow-list is built from `all-headers`.

   Each header name is written exactly once. Every other form — the Ring
   lowercase lookup keys, the CORS allow-list — is derived, so adding a header
   here makes it sent, parsed, and CORS-allowed everywhere at once.

   That is the whole point: SMS-279 added X-Active-Context-All-Branches to the
   tutorial client but not to the CORS allow-list, and because dev serves the
   webapp and API on different origins, every preflight carrying it 401'd with
   no CORS headers — breaking the dashboard for every multi-branch admin (#508)."
  (:require
   [clojure.string :as str]))

(def header
  "Active-context header names in canonical wire casing, keyed by payload.

   The only place these strings are written. Adding an entry here is the
   complete change — all consumers derive from it."
  {:school-id    "X-Active-Context-School-Id"
   :branch-id    "X-Active-Context-Branch-Id"
   :all-branches "X-Active-Context-All-Branches"})

(def all-headers
  "Every active-context header, canonical casing.

   The framework's CORS :access-control-allow-headers is built from this — a
   header absent from the allow-list is not a valid preflight, so the request
   never reaches the app."
  (vec (vals header)))

(def request-key
  "Header names as Ring exposes them on an incoming request.

   Ring lowercases incoming header names, so server-side lookups need the
   lowercase form. Derived from `header` rather than written again — two
   hand-maintained copies is the drift this namespace exists to remove."
  (reduce-kv (fn [m k v] (assoc m k (str/lower-case v))) {} header))

(def all-branches-value
  "Value the client sends for the All-Branches header.

   Presence alone is not the signal — the middleware compares against this
   exact string, so both sides must agree on it."
  "true")
